// Offline tempo + beat-phase detection on the decoded song (kick-weighted onset autocorrelation).
const cache = new Map();

const envelope = async (buffer) => {
  const sr = buffer.sampleRate;
  const off = new OfflineAudioContext(1, buffer.length, sr);
  const src = off.createBufferSource();
  src.buffer = buffer;
  const lp = off.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 180;
  src.connect(lp).connect(off.destination);
  src.start();
  const low = (await off.startRendering()).getChannelData(0);
  const hop = Math.round(sr / 100);
  const n = Math.floor(low.length / hop);
  const env = new Float32Array(n);
  for (let i = 0; i < n; i += 1) {
    let s = 0;
    for (let j = i * hop; j < (i + 1) * hop; j += 1) s += low[j] * low[j];
    env[i] = Math.sqrt(s / hop);
  }
  const onset = new Float32Array(n);
  for (let i = 1; i < n; i += 1) onset[i] = Math.max(0, env[i] - env[i - 1]);
  return { onset, fps: 100 };
};

const bestLag = (onset, fps) => {
  let best = { lag: 50, score: -1 };
  const minLag = Math.round((60 / 170) * fps);
  const maxLag = Math.round((60 / 75) * fps);
  for (let lag = minLag; lag <= maxLag; lag += 1) {
    let s = 0;
    for (let i = lag; i < onset.length; i += 1) s += onset[i] * onset[i - lag];
    const bpm = (60 * fps) / lag;
    const w = Math.exp(-((Math.log2(bpm / 120)) ** 2) / 0.5);
    if (s * w > best.score) best = { lag, score: s * w };
  }
  return best.lag;
};

const bestPhase = (onset, lag) => {
  let best = { off: 0, score: -1 };
  for (let o = 0; o < lag; o += 1) {
    let s = 0;
    for (let i = o; i < onset.length; i += lag) s += onset[i];
    if (s > best.score) best = { off: o, score: s };
  }
  return best.off;
};

export const analyzeTempo = async (url, ctx) => {
  if (cache.has(url)) return cache.get(url);
  const res = await fetch(url, { mode: "cors" });
  const buf = await ctx.decodeAudioData(await res.arrayBuffer());
  const { onset, fps } = await envelope(buf);
  const lag = bestLag(onset, fps);
  const off = bestPhase(onset, lag);
  const out = { bpm: Math.round((60 * fps) / lag), period: lag / fps, offset: off / fps };
  cache.set(url, out);
  return out;
};
